import React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { RootState } from "redux/store";
import * as kestrelEmbedCode from "shared/kestrel-embed-code";
import * as yup from "yup";
import { validate } from "shared/yup";
import { getAgentsWithLeads } from "redux/selector";
import { PropertyType } from "type/property-type";
import { WidgetConfigLayout } from "../widget-config-layout";
import { WidgetFieldGrid, WidgetFieldCell, WidgetSelect, WidgetNumber } from "../widget-fields";
import { getUser } from "redux/selector";
import { ListingSortType } from "type/listing-sort";

const mapStateToProps = (state: RootState) => {
	return {
		user: getUser(state),
		agents: getAgentsWithLeads(state),
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
}, dispatch);

interface Props extends
	ReturnType<typeof mapStateToProps>,
	ReturnType<typeof mapDispatchToProps> {
}

interface State {
	propertyTypeId: string;
	status: string;
	sort: string;
	resultsPerPage: number;
}

class Component extends React.Component<Props, State> {

	public constructor(props: Props) {
		super(props) 
		this.state = {
			propertyTypeId: "",
			status: "active",
			sort: "",
			resultsPerPage: 15,
		}
	}

	private validationSchema = {
		propertyTypeId: yup
			.string()
			.required("Property type is required."),
		status: yup
			.string()
			.required("Status is required."),
		sort: yup
			.string()
			.required("Sort is required."),
		resultsPerPage: yup
			.number()
			.required("Results Per Page is required.")
			.typeError("Results Per Page is required.")
			.min(1, "Results Per Page is required.")
			.max(50, "Max 50 results per page"),
	};

	public render() {
		const { user } = this.props;
		const { propertyTypeId, resultsPerPage, sort, status } = this.state;
		const errors = validate(this.validationSchema, this.state);
		const embedCode = kestrelEmbedCode.featuredListingWidget(
			user.websitePlatform,
			propertyTypeId,
			status,
			sort,
			resultsPerPage,
		);
		return (
			<WidgetConfigLayout user={user} embedCode={!errors ? embedCode : undefined}>
				<WidgetFieldGrid>
					<WidgetFieldCell>
						<WidgetSelect
							label="Property Type"
							required
							value={propertyTypeId}
							options={PropertyType.values().map((value) => ({value: value.id, label: value.label}))}
							onChange={(value) => this.setState({propertyTypeId: value})}
						/>
					</WidgetFieldCell>
					<WidgetFieldCell>
						<WidgetSelect
							label="Listing Status"
				required
							value={status}
							options={[{value: "active", label: "Active"}, {value: "sold", label: "Sold"}]}
							onChange={(value) => this.setState({status: value})}
						/>
					</WidgetFieldCell>
					<WidgetFieldCell>
						<WidgetSelect
							label="Sort"
							required
							value={sort}
							options={ListingSortType.values().map((value) => ({value: value.id, label: value.label}))}
							onChange={(value) => this.setState({sort: value})}
						/>
					</WidgetFieldCell>
					<WidgetFieldCell>
						<WidgetNumber
							label="Results Per Page"
							required
							min={1}
							max={50}
							value={resultsPerPage}
							onChange={(value) => this.setState({resultsPerPage: value})}
							helperText={errors && errors.resultsPerPage}
						/>
					</WidgetFieldCell>
				</WidgetFieldGrid>
			</WidgetConfigLayout>			
		);
	}
}

export const FeaturedListingsConfig = connect(mapStateToProps, mapDispatchToProps)(Component);
